import * as React from 'react';
import DocPlaceholder from 'react-showroom-doc-placeholder';
import { Article } from './article';
import { ComponentMeta } from './component-meta';
import { mdxComponents } from './mdx-components';
import { Div } from './base';
import { TableOfContent } from './table-of-content';
export const ComponentDocArticle = (props) => {
    const { doc: Doc, headings, editUrl } = props.content;
    const hasSideContent = (headings && headings.length > 0) || editUrl;
    return (React.createElement(Div, { css: hasSideContent
            ? {
                '@xl': {
                    display: 'flex',
                    flexDirection: 'row-reverse',
                },
            }
            : undefined },
        hasSideContent ? (React.createElement(TableOfContent, { headings: headings, editUrl: editUrl })) : null,
        React.createElement(Article, { css: hasSideContent
                ? {
                    '@xl': {
                        width: '75%',
                    },
                }
                : undefined },
            React.createElement(ComponentMeta, { componentData: props.metadata, slug: props.slug, propsDefaultOpen: true }),
            Doc ? (React.createElement(Doc, { components: mdxComponents })) : (React.createElement(DocPlaceholder, { componentFilePath: props.metadata.filePath })))));
};
//# sourceMappingURL=component-doc-article.js.map